import { LabelCardIconVariety } from "@components/Elements/Icon/LabelCardIcon";
import { CRAWL_START_DATE } from "@config/beyondWords";
import { ENABLE_TTS, IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";

export function shouldShowTTSPlayer(
  datetime: string,
  contentAccess: LabelCardIconVariety,
): boolean {
  if (
    IS_PLAYWRIGHT_TEST === "true" &&
    parseInt(ENABLE_TTS) === 1 &&
    contentAccess === LabelCardIconVariety.FREE
  ) {
    return true;
  }

  const startDate = new Date(CRAWL_START_DATE).getTime();
  const publishedTime =
    typeof datetime === "string" ? new Date(datetime).getTime() : 0;

  return (
    parseInt(ENABLE_TTS) === 1 &&
    contentAccess === LabelCardIconVariety.FREE &&
    publishedTime >= startDate
  );
}
